import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaBf_1.mjs'
import FormChoose from '../BF/FormChooseBf.jsx'
import TableChoose from '../BF/TableChooseBf.jsx'
import api from './apiBf_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
